import React from "react";
import ReactDOM from "react-dom";
import { Common } from "../../utils/common";
import CallDetailsReact from "./CallDetails";

const staticSelectInputs = {
  medium_type: {
    labelText: "Referral",
    options: [
      { label: "Organic", value: "organic" },
      { label: "Paid", value: "paid" },
      { label: "Referral", value: "referral" },
      { label: "Other", value: "other" },
      { label: "Direct", value: "direct" },
    ],
  },
  dial_status: {
    labelText: "Call Result",
    options: [
      { label: "Connected", value: "ANSWER" },
      { label: "No Answer", value: "NOANSWER" },
      { label: "Abandoned", value: "ABANDONED" },
      { label: "Busy", value: "BUSY" },
      { label: "Voicemail", value: "VOICEMAIL" },
    ],
  },
  ds_call_status: {
    labelText: "Connected Type",
    options: [
      { label: "Connected", value: "connected" },
      { label: "Voicemail", value: "voicemail" },
      { label: "Hang ups", value: "hangups" },
      { label: "Wrong department", value: "wrongdepartment" },
    ],
  },
};

class CallDetails extends HTMLElement {
  constructor() {
    super();
  }

  buildSelectInputs(staticSelectInputs, dealSaverFilters) {
    const { call_types, departments } = dealSaverFilters;

    const prospectOptions = call_types
      .filter((callType) => callType.is_prospect === 1)
      .map((callType) => ({ label: callType.text, value: callType.text }));

    const nonProspectOptions = call_types
      .filter((callType) => callType.is_prospect === 0)
      .map((callType) => ({ label: callType.text, value: callType.text }));

    return {
      ...staticSelectInputs,
      ds_department: {
        labelText: "Department",
        options: departments.map((department) => ({
          label: department,
          value: department,
        })),
      },
      ls_call_type: {
        labelText: "Call Types",
        options: [
          { label: "Prospects", options: prospectOptions },
          { label: "Non-Prospects", options: nonProspectOptions },
        ],
      },
    };
  }

  async connectedCallback() {
    this.innerHTML = `<div id="root"></div>`;

    this.domainId = this.getAttribute("domain_id");

    this.ls_call_type =
      this.getAttribute("ls_call_type") === "" ? "all" : this.getAttribute("ls_call_type");
    this.medium_type =
      this.getAttribute("medium_type") === "" ? "all" : this.getAttribute("medium_type");
    this.ds_appt_set =
      this.getAttribute("ds_appt_set") === "" ? "all" : this.getAttribute("ds_appt_set");
    this.ds_alert_sent =
      this.getAttribute("ds_alert_sent") === "" ? "all" : this.getAttribute("ds_alert_sent");
    this.ds_call_status =
      this.getAttribute("ds_call_status") === "" ? "all" : this.getAttribute("ds_call_status");

    let dealSaverFilters;

    if (Common.in_crm_mode()) {
      try {
        const res = await fetch(`/reports/domain_dealsaver_filters/${this.domainId}`, {
          headers: {'X-Requested-With': 'XMLHttpRequest'}
        });
        const data = await res.json();
        dealSaverFilters = data;
      } catch (error) {
        Common.notify("Something went wrong", "error");
      }
    } else {
      try {
        const res = await fetch("/reports/users_dealsaver_filters");
        const data = await res.json();
        dealSaverFilters = data;
      } catch (error) {
        Common.notify("Something went wrong", "error");
      }
    }

    // If ls_call_type is "prospects", we change the value to an array of all prospect types
    const prospectTypes = dealSaverFilters.call_types
      .filter((callType) => callType.is_prospect === 1)
      .map((callType) => ({ value: callType.text, label: callType.text }));

    if (this.ls_call_type === "prospects") {
      this.ls_call_type = prospectTypes;
    } else if (this.ls_call_type === "all") {
      this.ls_call_type = [];
    } else {
      this.ls_call_type = [{ label: this.ls_call_type, value: this.ls_call_type }];
    }

    const mediumTypeLabel = staticSelectInputs.medium_type.options.find(
      (option) => option.value === this.medium_type
    )?.label;
    if (this.medium_type === "all") {
      this.medium_type = [];
    } else {
      this.medium_type = [{ label: mediumTypeLabel, value: this.medium_type }];
    }

    const callStatusLabel = staticSelectInputs.ds_call_status.options.find(
      (option) => option.value === this.ds_call_status
    )?.label;
    if (this.ds_call_status === "all") {
      this.ds_call_status = [];
    } else {
      this.ds_call_status = [{ label: callStatusLabel, value: this.ds_call_status }];
    }

    this.ds_appt_set = this.ds_appt_set !== "all";

    this.ds_alert_sent = this.ds_alert_sent !== "all";

    ReactDOM.render(
      React.createElement(CallDetailsReact, {
        defaultFiltersFromURL: {
          medium_type: this.medium_type,
          ls_call_type: this.ls_call_type,
          ds_appt_set: this.ds_appt_set,
          ds_alert_sent: this.ds_alert_sent,
          ds_call_status: this.ds_call_status,
        },
        controllerName: this.getAttribute("controller_name"),
        domainId: this.domainId,
        selectInputs: this.buildSelectInputs(staticSelectInputs, dealSaverFilters),
      }),
      this.querySelector("#root")
    );
  }
}

customElements.define("call-details", CallDetails);
